module.exports = __webpack_public_path__ + "22fd537ee7b6650f96cb714bfcd1ab5d.svg";